import { render } from "./BalTabs.vue?vue&type=template&id=73973dda"
import script from "./BalTabs.vue?vue&type=script&lang=ts"
export * from "./BalTabs.vue?vue&type=script&lang=ts"

import "./BalTabs.vue?vue&type=style&index=0&id=73973dda&lang=css"
script.render = render

export default script